import Support from './ui/support';

export default Support;
